import BoxKit from "@/shared/components/kit/box";
import CardKit from "@/shared/components/kit/card";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import NorthWestIcon from "@mui/icons-material/NorthWest";
import CustomButton from "@/shared/components/kit/button";
import { useNavigate } from "react-router";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "@/style/global.css";
import useAccountStore from "@/store/balanceStore";
import { numberSeparator } from "@/hooks/useThousandsSeparator";
/**
 * WalletBalance
 *
 * نمایش موجودی کیف پول کاربر شامل موجودی نقدی و موجودی اعتباری.
 * دارای اسلایدر اتوماتیک بین دو نوع موجودی و دکمه افزایش موجودی.
 *
 * @returns JSX.Element
 */

const WalletBalance = () => {
  const navigate = useNavigate();
  const { balance, credit } = useAccountStore();

  return (
    <CardKit
      width={"100%"}
      height={179}
      title={
        <StackKit direction={"row"} justifyContent={"space-between"}>
          <StackKit direction={"row"} gap={2}>
            <CreditCardIcon style={{ color: "#fff" }} />
            <TypoGraphyKit>موجودی کیف پول</TypoGraphyKit>
          </StackKit>
          <BoxKit onClick={() => navigate("/wallet-reports/cash-balance-recharge")} sx={{boxSizing: "border-box",background:"linear-gradient(153.86deg, rgba(0, 0, 0, 0.4) -11.84%, rgba(37, 37, 37, 0.370427) 14.24%, rgba(78, 78, 78, 0.340413) 40.7%, rgba(0, 0, 0, 0.237218) 75.66%, rgba(0, 0, 0, 0.12) 106.2%)",backdropFilter: "blur(50px)",WebkitBackdropFilter: "blur(50px)",maxWidth: "100%",overflow: "hidden",borderRadius: "50%",padding: "3px",}}>
            <NorthWestIcon style={{ color: "#fff", width: "18px", height: "18px",cursor:'pointer' }}/>
          </BoxKit>
        </StackKit>
      }
      sx={{
        background:"linear-gradient(153.86deg, rgba(0, 0, 0, 0.4) -11.84%, rgba(37, 37, 37, 0.370427) 14.24%, rgba(78, 78, 78, 0.340413) 40.7%, rgba(0, 0, 0, 0.237218) 75.66%, rgba(0, 0, 0, 0.12) 106.2%)",
        backdropFilter:"blur(242.1999969482422px)",
        boxShadow: "-3px 0px 24px -3px #00000078",
      }}
    >
      <Swiper className="cardSlider" modules={[Autoplay]} autoplay={{delay: 2500,disableOnInteraction: false,}} loop={true} style={{ width: "100%", padding: 0 }}>
        <SwiperSlide style={{ background: "transparent", width: "100%", height: "100%" }}>
          <StackKit sx={{width: "100%",justifyContent: "center",alignItems: "center",}}>
            <StackKit direction={"row"} sx={{ width: "100%" }} alignItems={"center"} justifyContent={"space-between"}>
              <TypoGraphyKit variant="body1" sx={{ color: "#666666" }}>
                موجودی نقدی
              </TypoGraphyKit>
              <KeyboardArrowLeftIcon style={{ color: "#666666" }} />
            </StackKit>
            <StackKit direction={"row"} justifyContent={"space-between"} alignItems={"center"} sx={{ width: "100%" }}>
              <CustomButton onClick={() => navigate("/wallet-reports/cash-balance-recharge")}>
                <TypoGraphyKit variant="body1">افزایش موجودی</TypoGraphyKit>
              </CustomButton>
              <TypoGraphyKit variant="body1">
                {numberSeparator(balance)}
              </TypoGraphyKit>
              <TypoGraphyKit variant="body1">ریال</TypoGraphyKit>
            </StackKit>
          </StackKit>
        </SwiperSlide>
        <SwiperSlide style={{ background: "transparent", width: "100%", height: "100%" }}>
          <StackKit sx={{width: "100%",justifyContent: "center",alignItems: "center",}}>
            <StackKit direction={"row"} sx={{ width: "100%" }} alignItems={"center"} justifyContent={"space-between"}>
              <TypoGraphyKit variant="body1" sx={{ color: "#666666" }}>
                موجودی اعتباری
              </TypoGraphyKit>
              <KeyboardArrowLeftIcon style={{ color: "#666666" }} />
            </StackKit>
            <StackKit direction={"row"} justifyContent={"space-between"} alignItems={"center"} sx={{ width: "100%" }}>
              <CustomButton onClick={() => navigate("/")}>
                <TypoGraphyKit variant="body1">افزایش موجودی</TypoGraphyKit>
              </CustomButton>
              <TypoGraphyKit variant="body1">
                {numberSeparator(credit?.balance)}
              </TypoGraphyKit>
              <TypoGraphyKit variant="body1">ریال</TypoGraphyKit>
            </StackKit>
          </StackKit>
        </SwiperSlide>
      </Swiper>
    </CardKit>
  );
};

export default WalletBalance;
